import avatar from 'assets/img/team/avatar.png';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import React, { useEffect, useState } from 'react';
import { Col, Row, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import * as accessControlObj from '../../authentication/accessControlMap'
import DayProgramModal from './DayProgramModal';
import SharedLivingModal from './SharedLivingModal';
import { isSharedLivingActive } from 'helpers/isSharedLivingActive';
import { isSharedLivingPatient } from 'helpers/isSharedLivingFacility';


const PatientDetailsHeader = (props) => {

    //console.log("patientDetailsName" + props.username + props.facilityid + props.facility_name + props.patientid);
    const [mymActive, setMymActive] = useState(false);
    const [showDayPrograms, setShowDayPrograms] = useState(false);
    const [showCaregivers, setShowCaregivers] = useState(false);
    const objData = props.paramsObj
    const [dayProgramData, setDayProgramData] = useState(objData.day_programs);
    const [caregiverData, setCaregiverData] = useState(objData.athome_caregivers || []);
    const pname = props.patient_name
    const sharedLivingActive = isSharedLivingActive();
    const currentRoleId = Number(localStorage.getItem("roleId"));
    let localStorageAccessControl = localStorage.getItem("accessControl");
    let roleId = Number(localStorage.getItem("roleId"))
    const dayprogramActive = localStorageAccessControl.includes(accessControlObj.ACCESS_CONTROL["dayprogramactive"])

    useEffect(() => {
        if(localStorageAccessControl.includes(accessControlObj.ACCESS_CONTROL["mym"])) {
            setMymActive(true);
        }
    });

    const manageDayPrograms = () => {
        setShowDayPrograms(true);
    }

    return (
        <Card>
            <DayProgramModal
                show={showDayPrograms}
                onHide={() => setShowDayPrograms(false)}
                patientId={objData.id}
                patientName={pname}
                day_programs={dayProgramData}
                setDayProgramData={setDayProgramData}
            />
            <SharedLivingModal
                show={showCaregivers}
                onHide={() => setShowCaregivers(false)}
                patientId={objData.id}
                patientName={pname}
                setCaregiverData = {setCaregiverData}
            />
            <Card.Header className="pb-0 pt-4 mb-2">
                <h4 className="mb-1">
                    {props.patient_name}
                </h4>
            </Card.Header>
            <Card.Body className="py-0">
                <Row>
                    <Col lg={7}>
                        <Flex alignItems="center" className="mb-2">
                            <div className="flex-1">
                                <h6 className="mb-0">Allergies: <span className='text-danger'>{objData?.allergies_text}</span></h6>
                            </div>
                        </Flex>
                    </Col>
                    <Col lg={4} className="ps-2 ps-lg-3 me-0 ms-auto">
                        <Flex alignItems="center" className="mb-2">
                            <div className="flex-1">
                                <h6 className="mb-0">Facility Name: {objData.facility_name} </h6>
                            </div>
                        </Flex>
                        <Flex alignItems="center" className="mb-2">
                            <div className="flex-1">
                                <h6 className="mb-0">Group Name: {objData.group_name}</h6>
                            </div>
                        </Flex>
                        {dayprogramActive && <Flex alignItems="center" className="mb-2">
                            <div className="flex-1">
                                <h6 className="mb-0">Assigned Day Programs: {dayProgramData?.length > 0 ? dayProgramData?.map((program) => program.name).join(', ') : 'No day programs assigned'}</h6>
                            </div>
                        </Flex>}
                        {sharedLivingActive && <Flex alignItems="center" className="mb-2">
                            <div className="flex-1">
                                <h6 className="mb-0">Caregivers: {caregiverData?.length > 0 ? caregiverData?.map((c) => `${c.first_name || ''} ${c.last_name || ''}`.trim() || c.username).join(', ') : 'No caregivers assigned'}</h6>
                            </div>
                        </Flex>}
                        {/* UI-069 (refined): nurse + case-manager inline with the other staffing rows
                            instead of in a separate overlapping card. Stale (is_active = 0) state
                            is surfaced as a compact "(Inactive)" suffix. */}
                        {isSharedLivingPatient(objData) && objData.nurse && (() => {
                            const n = objData.nurse;
                            const name = `${n.first_name || ''} ${n.last_name || ''}`.trim() || `User #${n.id}`;
                            const inactive = !(n.is_active === 1 || n.is_active === '1' || n.is_active === true);
                            return (
                                <Flex alignItems="center" className="mb-2">
                                    <div className="flex-1">
                                        <h6 className="mb-0">
                                            Nurse: {name}
                                            {inactive && <span className="text-warning ms-1">(Inactive)</span>}
                                            {n.phone && (
                                                <a href={`tel:${n.phone}`} className="ms-2 fs-11 text-decoration-none">
                                                    {n.phone}
                                                </a>
                                            )}
                                        </h6>
                                    </div>
                                </Flex>
                            );
                        })()}
                        {isSharedLivingPatient(objData) && objData.case_manager && (() => {
                            const c = objData.case_manager;
                            const name = `${c.first_name || ''} ${c.last_name || ''}`.trim() || `User #${c.id}`;
                            const inactive = !(c.is_active === 1 || c.is_active === '1' || c.is_active === true);
                            return (
                                <Flex alignItems="center" className="mb-2">
                                    <div className="flex-1">
                                        <h6 className="mb-0">
                                            Case Manager: {name}
                                            {inactive && <span className="text-warning ms-1">(Inactive)</span>}
                                            {c.phone && (
                                                <a href={`tel:${c.phone}`} className="ms-2 fs-11 text-decoration-none">
                                                    {c.phone}
                                                </a>
                                            )}
                                        </h6>
                                    </div>
                                </Flex>
                            );
                        })()}
                    </Col>

                    <Row className="col-12 mx-0 w-100 avatar-profile-sec">
                        <Avatar
                            size='5xl'
                            className="avatar-profile col-1 mx-0 px-0 cursor-pointer"
                            src={objData.profile_image ? objData.profile_image : avatar }
                            mediaClass="img-thumbnail shadow-sm"
                            flag = {true}
                        />
                        <Col lg={10} className="border-top px-0 py-2 mt-3 ms-auto me-0 text-end">
                            <div className='d-inline mx-2 h6'>
                                {(Number(localStorage.getItem("roleId")) == 4) && dayprogramActive &&
                                    <Link state={{
                                        day_programs: objData.day_programs,
                                    }}>
                                    <Button size = 'sm' variant='outline' onClick={manageDayPrograms}>
                                        Manage Day Programs
                                    </Button>
                                    </Link>
                                    }
                            </div>
                            <div className='d-inline mx-2 h6'>
                                {currentRoleId <= 4 && sharedLivingActive &&
                                    <Button size='sm' variant='outline' onClick={() => setShowCaregivers(true)}>
                                        Manage Caregivers
                                    </Button>
                                }
                            </div>
                            <div className='d-inline mx-2 h6'>
                                {mymActive && (roleId < 7) &&
                                 <Link to={{ pathname: paths.addPrescription }} state={{
                                    facilityname: objData.facility_name,
                                    patientid: objData.id,
                                    orderid: null,
                                    patientname : props.patient_name
                                }} className='text-primary'>Add Prescription</Link>}
                            </div>
                            <div className='d-inline mx-2 h6'>
                                {mymActive && (roleId < 7) &&
                                 <Link to={{ pathname: paths.addMedicalRecord }} state={{
                                    facilityid: objData.facility_id,
                                    patientid: objData.id,
                                    medrecord_id: null
                                }} className='text-success' >Add Medical Record</Link>}
                            </div>
                        </Col>
                    </Row>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default PatientDetailsHeader;
